/**
 * Places Tab Content Component
 * Renders the places tab content for a response pair
 */

import React from 'react';
import { ChatLocation } from '@/types/chatTypes';
import {
  spacing,
  typographyColors,
  typography,
  fontPrimary,
} from '@/design-system/utils';
import { PlacesGridSection } from '../../places';

export interface PlacesTabContentProps {
  isActive: boolean;
  locations: ChatLocation[]; // All valid locations (tourist attractions and businesses)
  onCardClick?: (cardId: string) => void;
}

export const PlacesTabContent: React.FC<PlacesTabContentProps> = ({
  isActive,
  locations,
  onCardClick,
}) => {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        display: isActive ? 'block' : 'none', // Hide instead of unmounting
        paddingBottom: spacing[4],
      }}
    >
      {/* Places of Relevance - Grid View */}
      {locations && locations.length > 0 ? (
        <PlacesGridSection
          title='Places of Relevance'
          locations={locations}
          onCardClick={onCardClick}
          showHeader={false}
        />
      ) : (
        <div
          style={{
            padding: spacing[8],
            textAlign: 'center',
            color: typographyColors.secondary,
            fontFamily: fontPrimary,
            fontSize: typography.size.base,
          }}
        >
          No places available at the moment.
        </div>
      )}
    </div>
  );
};
